var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.419,
    height: 28.415,
    viewBox: "0 0 28.419 28.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_180",
    "data-name": "Trac\\xE9 180",
    d: "M20.856,18.371a11.545,11.545,0,1,0-2.481,2.483h0a2.078,2.078,0,0,0,.174.2L25.385,27.9A1.776,1.776,0,0,0,27.9,25.385L21.06,18.547a1.789,1.789,0,0,0-.2-.178Zm.458-6.827a9.769,9.769,0,1,1-9.769-9.769,9.769,9.769,0,0,1,9.769,9.769Z",
    transform: "translate(0.001 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoop);
export default __webpack_public_path__ + "static/media/icon-loop.0b446a5aec61a495afba30f9bf367cff.svg";
export { ForwardRef as ReactComponent };